import React, { useEffect } from "react"
import { authContext } from "../../services/adalConfig"
// import { authContext } from "../../services/keycloakConfig"

const Logout = (props) => {
    useEffect(() => {
        authContext.logOut()
        // authContext.logout()
        sessionStorage.clear()
        localStorage.clear()
        props.logoutUser(props.history)
    })

    return <></>
}

export default Logout
